import { minify } from 'html-minifier-terser'

// Helper function to determine the base URL based on environment
export const getBaseURL = () => {
  return process.env.VUE_APP_HOST || 'https://linkbook.io'
}

export const WelcomeEmail = async () => {
  const welcomeHTML = await fetch(
    '/email-templates/html/welcome/welcome.html'
  ).then(response => response.text())

  // Replace domain placeholder with the appropriate domain
  const processedHTML = welcomeHTML.replace(/\{\{domain\}\}/g, getBaseURL())

  const email = {
    subject:
      'Welcome to LinkBook.io - Your Ultimate Digital Bookmark Manager Companion',
    html: minifyHTML(processedHTML)
  }
  return email
}

export const FeatureAnnouncementEmail = async (userEmail, unsubscribeToken) => {
  const baseURL = getBaseURL()
  const featureHTML = await fetch(
    `${baseURL}/email-templates/html/marketing/template-1.html`
  ).then(response => response.text())

  // Replace all linkbook.io URLs with the appropriate base URL
  let processedHTML = featureHTML
    .replace(/https:\/\/linkbook\.io/g, baseURL)
    .replace(/\{\{userEmail\}\}/g, userEmail)
    .replace(/\{\{unsubscribeToken\}\}/g, unsubscribeToken)

  const email = {
    subject:
      "New Features at LinkBook.io - We've Added More Power to Your Bookmarks!",
    html: minifyHTML(processedHTML)
  }
  return email
}

export const WorkspaceInvite = async emailLink => {
  const HTML = await fetch(
    '/email-templates/html/workspace/invite.html'
  ).then(response => response.text())

  const processedHTML = HTML.replace(/\{\{emailLink\}\}/g, emailLink).replace(
    /\{\{domain\}\}/g,
    getBaseURL()
  )

  const email = {
    subject: 'LinkBook.io - You have been invited to a workspace',
    html: minifyHTML(processedHTML)
  }
  return email
}

export const WorkspaceRoleChangedEmail = async ({
  groupName,
  previousRole,
  newRole,
  workspaceLink,
  memberName
}) => {
  const escapeHtml = value =>
    String(value || '').replace(/[&<>"']/g, character => {
      const entities = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }
      return entities[character]
    })

  const roleLabels = {
    member: 'Member',
    editor: 'Editor',
    admin: 'Admin',
    owner: 'Owner'
  }
  const formatRole = role => roleLabels[role] || role || 'Member'
  const safeGroupName = escapeHtml(groupName)
  const safePreviousRole = escapeHtml(formatRole(previousRole))
  const safeNewRole = escapeHtml(formatRole(newRole))
  const safeWorkspaceLink = escapeHtml(workspaceLink)
  const safeMemberName = escapeHtml(memberName || 'there')
  const html = `
    <div style="margin:0;padding:32px;background:#f4f6f8;font-family:Arial,sans-serif;color:#1a2332;">
      <div style="max-width:560px;margin:0 auto;background:#ffffff;border:1px solid #e8ecf0;border-radius:12px;overflow:hidden;">
        <div style="padding:28px 32px;background:#0f172a;color:#ffffff;">
          <p style="margin:0 0 10px;color:#60a5fa;font-size:12px;font-weight:600;letter-spacing:1px;text-transform:uppercase;">Workspace update</p>
          <h1 style="margin:0;font-size:26px;">Your role has changed</h1>
        </div>
        <div style="padding:32px;line-height:1.6;">
          <p>Hi ${safeMemberName},</p>
          <p>Your role in <strong>${safeGroupName}</strong> has changed from <strong>${safePreviousRole}</strong> to <strong>${safeNewRole}</strong>.</p>
          <p style="margin:28px 0;"><a href="${safeWorkspaceLink}" style="display:inline-block;padding:13px 24px;background:#1976d2;border-radius:8px;color:#ffffff;text-decoration:none;font-weight:600;">Open Workspace</a></p>
          <p style="font-size:13px;color:#64748b;">You’re receiving this because you’re a member of the ${safeGroupName} workspace. <a href="${escapeHtml(
    getBaseURL()
  )}/profile#email" style="color:#1976d2;">Manage email preferences</a>.</p>
          <p>Thank you,<br><strong>The Linkbook.io Team</strong></p>
        </div>
      </div>
    </div>`

  return {
    subject: `Your role in ${groupName} has changed`,
    html: await minifyHTML(html)
  }
}

export const AdvertApproved = async () => {
  const templateApproved = await fetch(
    '/email-templates/html/adverts/approved.html'
  ).then(response => response.text())

  // Replace domain placeholder with the appropriate domain
  const processedHTML = templateApproved.replace(
    /\{\{domain\}\}/g,
    getBaseURL()
  )

  const email = {
    subject: 'LinkBook.io promo - has been approved',
    html: minifyHTML(processedHTML)
  }
  return email
}

export const AdvertUnapproved = async () => {
  const templateUnapproved = await fetch(
    '/email-templates/html/adverts/unapproved.html'
  ).then(response => response.text())

  // Replace domain placeholder with the appropriate domain
  const processedHTML = templateUnapproved.replace(
    /\{\{domain\}\}/g,
    getBaseURL()
  )

  const email = {
    subject: 'LinkBook.io promo - has been unapproved',
    html: minifyHTML(processedHTML)
  }
  return email
}

function minifyHTML(html) {
  const result = minify(html, {
    removeAttributeQuotes: true
    // Add other minification options as needed
  })
  return result
}
